import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/home/src/app/[locale]/[city]/components/city-page-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/home/src/app/[locale]/[city]/components/session/solomeal-container.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
